module.exports = __webpack_public_path__ + "static/media/optioned-building-black.d956a303.svg";